export const mapConfig: {
  maQuanHuyen: string,
  maPhuongXa: string,
  maDuong: string,
  quanHuyenUrl: string;
  phuongXaUrl: string;
  arcgisUrl: string;
  printService: string;
  geometryService: string;
  center: number[];
  scale: number;
  proxy?: string;
} = {
  maQuanHuyen: '',
  maPhuongXa: '',
  maDuong: '',
  quanHuyenUrl: '',
  phuongXaUrl: '',
  arcgisUrl: '',
  printService: '',
  geometryService: '',
  center: [],
  scale: 0
}

export const LAYER = {
  BASE_MAP: 'basemap',
  DIEM_SU_CO: 'diemsucoLYR',
  QuyHoachChiTiet: 'quyhoachchitiet',
  ThongTinQuyHoachCached: 'ttqhsddCached',
  ThongTinDoAn: 'TTDA_ThongTinDoAn',
  HanhChinhHuyen:'HanhChinhHuyen'
};

export const APP_LAYER = {
};

export const FIELDS_NO_EDIT = [
  'MaPhuongXa',
  'SHAPE_Length',
  'MaHuyenTP',
  'MaXa',
  'OBJECTID',
  'MaDMA',
  'GlobalID',
  'DoiQuanLy',
  'TGPhanAnh',
  'created_user',
  'created_date',
  'last_edited_user',
  'last_edited_date'
];
